import $ from 'jquery';

class editModeEvents {

  constructor() {
    this.isTopNavOpened = false;
    this.isToolboxOpened = false;
    this.events();
  };

  
  events(){
    $(".object-menu").on("wheel", (e)=> {e.stopPropagation();} )

    // Object settings tabs
    $(document).on('click', '.object-settings-tab', (e) => {
      const tab = $(e.currentTarget);
      const tabName = tab.data('tab');
      $('.object-settings-tab').removeClass('active');
      tab.addClass('active');
      $('.object-settings-tab-panel').removeClass('active');
      $(`.object-settings-tab-${tabName}`).addClass('active');
    });

    //TOP NAV three dots (on mobile)
    $(document).on('click', '.topnav_more', (e) => {
      if(this.isTopNavOpened && $('.topnav_more_dopdown').hasClass('is-active')){
        $('.topnav_more_dopdown').removeClass("is-active");
        this.isTopNavOpened = false;
        return;
      }
      this.isTopNavOpened = true;
      $('.topnav_more_dopdown').addClass("is-active");
          
    });

    //TOOLBOX

    $(document).on('click', '.openToolbox, .mini-tools-menu', (e) => {
      $('#css3d').trigger('click');
      console.log('openToolbox');
      if(this.isToolboxOpened && $('.buttons-holder').hasClass('visible')){
          this.isToolboxOpened = false;
          $('.buttons-holder').removeClass("visible");
          return;
      }
      this.isToolboxOpened = true;
      $('.buttons-holder').addClass("visible");
    });



    // CLOSE opened target on document click
    $(document).on('click', (e) => {
      //TOP NAV three dots (on mobile)
      if(this.isTopNavOpened && !$(e.target).is('.topnav_more') ){
        $('.topnav_more_dopdown').removeClass("is-active");
        this.isTopNavOpened = false;
      }
      //TOOLBOX
      if(this.isToolboxOpened ){

        // console.log('isToolboxOpened',this.isToolboxOpened);
        // $('#css3d').trigger('click');
        var container = document.getElementsByClassName('search-box')[0];
        if (container.contains(e.target)) {    
          console.log('clicking inside the div');
          return;
        }
        if( $(e.target).is('.openToolbox') ){ return }
        // if (container !== e.target && !container.contains(e.target)) {    
        //   console.log('clicking outside the div');
        // }
        $('.buttons-holder').removeClass("visible");
        this.isToolboxOpened = false;
      }
    });


    $('#searchTool').on('keyup change', function (e){
      var value = $('#searchTool').val().toLowerCase();
      $(".maxi-tools-menu li .txt").filter(function() {
        if($(this).text().toLowerCase().indexOf(value) > -1){
          $(this).parent().css('display','grid');
          $('#toolbox .buttons-holder').parent().css('height','auto');
          $('.search-box').removeClass('has-results');
        }else{
          $('.search-box').addClass('has-results');
          $(this).parent().css('display','none');
          $('#toolbox .buttons-holder').parent().css('height','648px');
        }
      });
    });

    $(document).on('click', '.reset-search-tool', (e) => {
      $('#searchTool').val('');
      $('#searchTool').trigger('change');
    });


  }

}

export { editModeEvents }